import { scorT, getScorLocale } from 'i18n/scorLocale';

export const formatScorInvoiceMoney = (
  amountMinor?: number | null,
  amountRub?: number | null
): string => {
  if (typeof amountMinor !== 'number' || !Number.isSafeInteger(amountMinor)) {
    return typeof amountRub === 'number'
      ? new Intl.NumberFormat(getScorLocale(), {
          style: 'currency',
          currency: 'RUB',
          maximumFractionDigits: 0,
        }).format(amountRub)
      : scorT('onRequest');
  }

  const absoluteAmount = Math.abs(amountMinor);
  const rubles = Math.floor(absoluteAmount / 100);
  const kopecks = String(absoluteAmount % 100).padStart(2, '0');
  const parts = new Intl.NumberFormat(getScorLocale(), {
    style: 'currency', currency: 'RUB', minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).formatToParts(rubles);

  return `${amountMinor < 0 ? '−' : ''}${parts.map((part) => part.type === 'fraction' ? kopecks : part.value).join('')}`;
};

const finalInvoiceStatuses = new Set([2, 8, 9]);

export const isScorInvoiceFinalStatus = (status?: number): boolean =>
  typeof status === 'number' && finalInvoiceStatuses.has(status);
